import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-24-back",
  "use": "icon-icon-24-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon-24-back\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M0 0h24v24H0z\" /><path d=\"M10.914 5.64a1 1 0 0 1 0 1.414L6.968 11H20a1 1 0 0 1 0 2H6.96l3.954 3.954A1 1 0 0 1 9.5 18.368l-4.949-4.95-.708-.707a1 1 0 0 1 0-1.414L9.5 5.64a1 1 0 0 1 1.414 0z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol